/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import configData from '../config.json';
import { qreq } from './qrequest';

class _Globals {

    constructor() {
        this.globals = {};
        this.appName = configData.APP_TITLE;
        this.serverUrl = configData.SERVER_URL;
        this.outsidePaths = ['/login', '/user-invite', '/set-password', '/payment-request'];
        this.neutralPaths = ['/medical-release/request', '/form/request'];
        this.formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }

    getCurrencyFormatter() {
        return this.formatter;
    }

    formatCurrency(c) {
        if(isNaN(c))
            return '';
        return this.formatter.format(c);
    }

    set(a, b) {
        this.globals[a] = b;
    }
    get(a) {
        return this.globals[a];
    }

    async getSettings() {
        return new Promise((resolve, reject) => {
                
            if (this.publicSettings) {
                resolve(this.publicSettings);
                return;
            }

            qreq.get('/api/settings/get/public', j => {
                if(j.item) {
                    this.publicSettings = j.item;
                    resolve(this.publicSettings);
                }
                else
                    reject(j.errorMessage);
            }, () => {
                reject('An unkown error ocurred. Settings service might be down.');
            });
        });
    }

    isDiffObject(a, b, testInvert) {
        if (a !== b)
            return true;
        if (typeof (a) !== typeof (b))
            return true;
        if (a && b) {
            for (var k in a) {
                if (a[k] !== b[k]) {
                    return true;
                }
                else if (typeof (a[k]) === 'object') {
                    if (!a[k] && !b[k])
                        continue;
                    if (this.isDiffObject(a[k], b[k])) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    isEmptyOrWhitespace(a) {
        if (!a || a.length === 0 || a.trim().length === 0)
            return true;
        return false;
    }

    getImageURL(url) {
        if (!url || url.length === 0)
            return '';
        if (url.startsWith('http'))
            return url;
        return this.serverUrl + url;
    }

    getStorageURL(fileIdent, isImg) {
        if (!fileIdent || fileIdent.length === 0)
            return '/img/placeholder.png';
        return this.serverUrl + (isImg ? '/api/storage/image/' + fileIdent : '/api/storage/file/' + fileIdent);
    }

    toZ(str) {
        return str.replace('Z','') + 'Z';
    }

    toMDYDateString(d) {
        if(!d)
            return d;
        if(d === 'Unknown')
            return d;
        if (!d.getMonth)
            d = new Date(Date.parse(this.toZ(d)));
        function pad(n) { return n < 10 ? '0' + n : n };
        if(!d.getMonth)
            return '';
        let s = pad(d.getUTCMonth() + 1) + '/' + pad(d.getUTCDate()) + '/' + d.getUTCFullYear();
        if(s === '01/01/1')
            return '';
        return s;
    }

    toMDYLocalDateString(d) {
        if(!d)
            return d;
        function pad(n) { return n < 10 ? '0' + n : n };
        if (!d.getMonth)
            d = new Date(Date.parse(this.toZ(d)));
        if(!d.getMonth)
            return '';
        return pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear();
    }

    toLongLocalDateString(d) {
        if(!d)
            return d;
        if (!d.getMonth)
            d = new Date(Date.parse(this.toZ(d)));
        if(!d.getMonth)
            return '';
        return d.toDateString();
    }

    toMDYHMLocalDateString(d) {
        if(!d)
            return d;
        function pad(n) { return n < 10 ? '0' + n : n };
        if (!d.getMonth)
            d = new Date(Date.parse(this.toZ(d)));

        if(!d.getMonth)
            return '';

        if(d.getTime() < Date.parse('1900-01-01'))
            return 'N/A';

        var h = Number(d.getHours());
        var ap = 'AM';
        if (h > 12) {
            h -= 12;
            ap = 'PM';
        }
        else if (h === 12) {
            ap = 'PM';
        }
        if(h === 0)
            h = 12;
        return pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear() + ' ' + pad(h) + ':' + pad(d.getMinutes()) + ' ' + ap;
    }

    toMDYHMLocalDateStringOrDiff(d, showToday, ago) {
        if(!d)
            return d;
        function pad(n) { return n < 10 ? '0' + n : n };
        if (!d.getMonth)
            d = new Date(Date.parse(this.toZ(d)));

        if(!d.getMonth)
            return '';

        const now = new Date();

        const diffTime = Math.abs(d - now); // Difference in milliseconds
        const deffSeconds = Math.floor(diffTime / 1000); // Convert to seconds
        const diffMinutes = Math.floor(diffTime / (1000 * 60)); // Convert to minutes
        const diffHours = Math.floor(diffTime / (1000 * 60 * 60)); // Convert to hours
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Convert to days


        if(ago) {
            if(diffDays < 1) {
                if(diffHours < 1) {
                    if(diffMinutes < 1)
                        return "Just now";
                    else
                        return diffMinutes + " minutes ago";
                }
                else
                    return diffHours + " hours ago";
            }
        }

        var h = Number(d.getHours());
        var ap = 'AM';
        if (h > 12) {
            h -= 12;
            ap = 'PM';
        }
        else if (h === 12) {
            ap = 'PM';
        }
        
        if(diffDays < 1) {
            return (showToday ? 'Today ' : '') + pad(h) + ':' + pad(d.getMinutes()) + ' ' + ap;
        }


        return pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear() + ' ' + pad(h) + ':' + pad(d.getMinutes()) + ' ' + ap;
    }

    toDateOnlyString(d) {
        if(!d)
            return d;
        function pad(n) { return n < 10 ? '0' + n : n }
        if (!d.getMonth)
            d = new Date(Date.parse(d + 'Z'));
        if(!d.getMonth)
            return '';
        return d.getUTCFullYear() + '-'
            + pad(d.getUTCMonth() + 1) + '-'
            + pad(d.getUTCDate());
    }

    toISODateString(d) {
        if(!d)
            return d;
        if (!d.getMonth)
            d = new Date(Date.parse(d + 'Z'));
        if(!d.getMonth)
            return '';
        function pad(n) { return n < 10 ? '0' + n : n }
        return d.getUTCFullYear() + '-'
            + pad(d.getUTCMonth() + 1) + '-'
            + pad(d.getUTCDate()) + 'T'
            + pad(d.getUTCHours()) + ':'
            + pad(d.getUTCMinutes()) + ':'
            + pad(d.getUTCSeconds()) + 'Z';
    }

    toISOLocalDateString(d) {
        if(!d)
            return d;
        if (!d.getMonth)
            d = new Date(Date.parse(d));
        if(!d.getMonth)
            return '';
        function pad(n) { return n < 10 ? '0' + n : n }
        return d.getFullYear() + '-'
            + pad(d.getMonth() + 1) + '-'
            + pad(d.getDate()) + 'T'
            + pad(d.getHours()) + ':'
            + pad(d.getMinutes()) + ':'
            + pad(d.getSeconds());
    }

    getTimeOnly(d) {
        if(!d)
            return d;
        if (!d.getMonth)
            d = new Date(Date.parse(d));
        if(!d.getMonth)
            return '';
        function pad(n) { return n < 10 ? '0' + n : n }
        return pad(d.getHours()) + ':'
            + pad(d.getMinutes());
    }

    getTimeOfDay() {
        var d = new Date();
        var h = d.getHours();
        if (h < 12)
            return 'morning';
        if (h < 17)
            return 'afternoon';
        return 'evening';
    }

    getOutsidePath(loc) {
        var r = null;
        this.outsidePaths.forEach(i => {
            if (loc.length >= i.length && loc.substring(0, i.length) === i) {
                r = i;
            }
        });
        return r;
    }

    isOutsidePath(loc) {
        return (this.getOutsidePath(loc) !== null);
    }

    getNeutralPath(loc) {
        var r = null;
        this.neutralPaths.forEach(i => {
            if (loc.length >= i.length && loc.substring(0, i.length) === i) {
                r = i;
            }
        });
        return r;
    }

    deepClone(a, exclude) {
        if (!Array.isArray(exclude))
            exclude = [exclude];
        var b = {};
        for (var i in a) {
            if (exclude.indexOf(i) === -1)
                b[i] = a[i];
        }
        return b;
    }

    deepCopy(src, dst, exclude) {
        if (!Array.isArray(exclude))
            exclude = [exclude];
        for (var i in src) {
            if (exclude.indexOf(i) === -1)
                dst[i] = src[i];
        }
    }

    emptyObj(obj, exclude) {
        if (!Array.isArray(exclude))
            exclude = [exclude];
        for (var i in obj) {
            if(exclude.indexOf(i) === -1)
                delete obj[i];
        }
    }

    isMobile() {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    processResultObject(obj, excludeProps) {
        try {
            if (typeof (obj) === 'object') {
                for (var k in obj) {
                    if(excludeProps && excludeProps.indexOf(k) !== -1)
                        continue;
                    if (Array.isArray(obj[k])) {
                        obj[k].forEach(i => {
                            this.processResultObject(i, excludeProps);
                        });
                    }
                    else {
                        var s = obj[k];
                        if (s) {
                            if (s.toLowerCase && s === '0001-01-01T00:00:00')
                                obj[k] = this.toISOLocalDateString(new Date());
                            else {
                                if (s.endsWith && !s.endsWith('Z'))
                                    s += 'Z';
                                var v = Date.parse(s);
                                if (s.indexOf && s.indexOf('-') !== -1 && !isNaN(v)) {
                                    var d = new Date(v);
                                    obj[k] = this.toISOLocalDateString(d);
                                }
                                else if (typeof (obj[k]) === 'object') {
                                    this.processResultObject(obj[k], excludeProps);
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            console.log('exception', e);
        }
    }

    getTimeZone() {
        const options = {
            timeZoneName: 'long'
        };
        const formatter = new Intl.DateTimeFormat('en-US', options);
        const parts = formatter.formatToParts();
        const timeZone = parts.find(part => part.type === 'timeZoneName').value;
        console.log(`Your full timezone name is: ${timeZone}`);
        return timeZone;
    }

    getTimeZoneForQuery() {
        return encodeURIComponent(this.getTimeZone());
    }

    getTimeZoneOffset() {
        return new Date().getTimezoneOffset();
    }
    

    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }
        return 'unknown';
    }

    isIOS() {
        return this.getMobileOperatingSystem() === 'iOS';
    }

    isAndroid() {
        return this.getMobileOperatingSystem() === 'Android';
    }
}

const Globals = new _Globals();

export default Globals;